import clsx from 'clsx'
import { type ReactNode, type ComponentPropsWithoutRef, type FC } from 'react'
import { FaExclamationCircle } from 'react-icons/fa'

import { alertRootVariant, alertTitleVariant } from './alert-variants'

type Props = ComponentPropsWithoutRef<'div'> & {
  title?: ReactNode
  children: ReactNode
  color?: 'default' | 'yellow' | 'red'
}

export const Alert: FC<Props> = ({
  className,
  title,
  children,
  color = 'default',
  ...props
}) => {
  return (
    <div {...props} className={clsx([alertRootVariant({ color }), className])}>
      {title && (
        <div className={clsx([alertTitleVariant({ color })])}>
          <FaExclamationCircle />
          {title}
        </div>
      )}
      <div>{children}</div>
    </div>
  )
}
